import React from "react"

import ClassModule from "components/class-module"

const ContentfulClassModule = ({ component }) => {
  const { titleCM: title, description, lessons, id } = component

  return (
    <ClassModule
      dataId={id}
      title={title}
      description={description && description.childMarkdownRemark.html}
      lessons={lessons}
    />
  )
}

export default ContentfulClassModule
